"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowUpRight } from "lucide-react";
import { isSafeHref } from "../types";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
import type { CampaignSectionStyle } from "@growwithai/shared";

// Tipe lokal (bukan Extract dari shared) — kontrak section 'links' bisa mendarat
// terpisah di @growwithai/shared; komponen ini defensif terhadap absensinya.
export interface LinksSectionData {
  id: string;
  type: "links";
  hidden?: boolean;
  title?: string;
  items: {
    label: string;
    url: string;
    icon?: string;
  }[];
  custom_style?: CampaignSectionStyle;
}

/** Daftar tombol besar gaya link-in-bio: full-width, rounded-xl, tap target ≥48px. */
export default function LinksSection(t0) {
  const $ = _c(26);
  const {
    section
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== section.custom_style || $[1] !== section.items || $[2] !== section.title) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const items = (section.items ?? []).filter(_temp);
      if (items.length === 0) {
        t7 = null;
        break bb0;
      }
      t5 = "bg-white py-14 md:py-20";
      if ($[10] !== section.custom_style) {
        t6 = sectionBgStyle(section.custom_style);
        $[10] = section.custom_style;
        $[11] = t6;
      } else {
        t6 = $[11];
      }
      t3 = "mx-auto max-w-md px-5";
      if ($[12] !== section.custom_style || $[13] !== section.title) {
        t4 = section.title && <h2 className="mb-6 text-center text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={sectionHeadingStyle(section.custom_style)}>{section.title}</h2>;
        $[12] = section.custom_style;
        $[13] = section.title;
        $[14] = t4;
      } else {
        t4 = $[14];
      }
      t1 = "space-y-3";
      t2 = items.map(_temp2);
    }
    $[0] = section.custom_style;
    $[1] = section.items;
    $[2] = section.title;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[15] !== t1 || $[16] !== t2) {
    t8 = <div className={t1}>{t2}</div>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t8) {
    t9 = <div className={t3}>{t4}{t8}</div>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t5 || $[23] !== t6 || $[24] !== t9) {
    t10 = <section className={t5} style={t6}>{t9}</section>;
    $[22] = t5;
    $[23] = t6;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function _temp2(item, i) {
  const external = /^https?:\/\//i.test(item.url);
  return <a key={i} href={item.url} {...external ? {
    target: "_blank",
    rel: "noopener noreferrer"
  } : {}} className="group flex min-h-[48px] w-full items-center gap-3 rounded-xl border border-[var(--brand-primary)]/25 bg-white px-5 py-3.5 text-sm font-semibold text-warm-black shadow-sm transition-all hover:border-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_6%,white)] active:scale-[0.99]">{item.icon && <span aria-hidden={true} className="shrink-0 text-lg leading-none">{item.icon}</span>}<span className="min-w-0 flex-1 truncate text-center">{item.label}</span><ArrowUpRight className="h-4 w-4 shrink-0 text-[var(--brand-primary)] opacity-0 transition-opacity group-hover:opacity-100" aria-hidden={true} /></a>;
}
function _temp(it) {
  return it && typeof it.label === "string" && it.label.trim() !== "" && typeof it.url === "string" && isSafeHref(it.url);
}